import React from 'react';
import CarouselScreen from '../../../components/CarouselScreen';
import tdSphere from '../../../assets/images/td_sphere.png';

function PatientInformationIntro() {
  const slides = [
    {
      title: "Your Information",
      content: [
        "In this section, we ask for your personal details so we can set up your records and provide care that's tailored to you.",
        "We understand that some questions may be personal or sensitive. You're welcome to skip any questions you're not comfortable answering.",
        "Everything you tell us is kept private and will only be used for your care."
      ],
      ctaText: "Go to Questions",
      route: "/forms/your-information"
    },
    {
      title: "How to Complete This Form",
      content: [
        "Take your time to answer each question thoughtfully - there's no rush.",
        "We've included explanations for some questions. Look for the (?) icon if you need more information.",
        "You can save your progress and return to complete this section later.",
        "If you're not sure about any questions, it's okay to leave them blank."
      ],
      ctaText: "Go to Questions",
      route: "/forms/your-information"
    }
  ];

  return (
    <div className="min-h-screen">
      <div className="h-10 md:h-40 w-full fixed top-0 left-0 z-10">
        <div className="absolute inset-0 bg-gradient-to-r from-pink-200 via-purple-200 to-blue-200 opacity-80"></div>
      </div>
      <CarouselScreen 
        slides={slides}
        bgColor="bg-violet-900"
        logo={tdSphere}
        logoAlt="ThinkDivergent Sphere"
        showBackButton={true}
      />
    </div>
  );
}

export default PatientInformationIntro;